"use client";

import { useEffect } from "react";
import { defaultPageBackgroundColorData } from "./default";
import type { PageBackgroundColorType } from "./types";

interface PageBackgroundColorProps {
  data?: PageBackgroundColorType;
}

const PageBackgroundColor = ({ data }: PageBackgroundColorProps) => {
  const resolvedData = data ?? defaultPageBackgroundColorData;
  const backgroundColor = resolvedData.backgroundColor?.trim() ?? "";

  useEffect(() => {
    if (!backgroundColor) return;

    const previousBackgroundColor = document.body.style.backgroundColor;
    document.body.style.backgroundColor = backgroundColor;

    return () => {
      document.body.style.backgroundColor = previousBackgroundColor;
    };
  }, [backgroundColor]);

  return null;
};

export default PageBackgroundColor;
